import { render, staticRenderFns } from "./ASelectColumnForm.vue?vue&type=template&id=592b4676&"
import script from "./ASelectColumnForm.vue?vue&type=script&lang=js&"
export * from "./ASelectColumnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports